import React from 'react';
import {
  CanonicalSpotSymbol,
  VENUE_METADATA,
  toShortSymbol,
} from '../../shared/constants/watchlist';

export interface CryptoSymbolCellProps {
  symbol: CanonicalSpotSymbol | string;
  showVenue?: boolean;
  showRole?: boolean;
  className?: string;
}

export const CryptoSymbolCell: React.FC<CryptoSymbolCellProps> = ({
  symbol,
  showVenue = false,
  showRole = true,
  className = '',
}) => {
  const canonSym = (symbol.endsWith('USDT') ? symbol : `${symbol}USDT`) as CanonicalSpotSymbol;
  const meta = VENUE_METADATA[canonSym] ?? null;
  const short = toShortSymbol(symbol);

  return (
    <div
      className={`crypto-symbol-cell ${className}`}
      title={meta ? `流动性主市场: ${meta.venue} (${meta.role})` : undefined}
    >
      <div className="crypto-symbol-row-top">
        <span className="crypto-symbol-text font-mono">
          <span>{short}</span>
          <span className="text-muted" style={{ fontWeight: 400 }}>/USDT</span>
        </span>
        {showVenue && meta && (
          <span className={`venue-pill ${meta.badgeClass}`} title={`流动性主市场: ${meta.venue}`}>
            {meta.venue}
          </span>
        )}
      </div>
      {showRole && meta && (
        <span className="crypto-symbol-role" title={meta.detailedRole}>
          {meta.role}
        </span>
      )}
    </div>
  );
};
